// extracted by mini-css-extract-plugin
export default {"facebook__btn":"Register_facebook__btn__Ir123","google__btn":"Register_google__btn__UY71j"};